import parsePhoneNumber from 'libphonenumber-js';

export function formatStringPhoneUS(phoneString) {
    let formattedPhoneNumber = phoneString;
    const phoneNumber = parsePhoneNumber(phoneString, 'US');

    // If phoneNumber is undefined, then parsePhoneNumber can't parse specified phone string
    if (phoneNumber !== undefined) {
        formattedPhoneNumber = phoneNumber.formatNational();
    }

    return formattedPhoneNumber;
}
